import { g as c } from "../../utils-BOfnFgIH.js";
import { I as i } from "../../constants-DeVuDy8J.js";
import { createElementBlock as l, openBlock as a, normalizeClass as r, createElementVNode as o, createStaticVNode as s } from "vue";
import { _ as n } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const f = {
  name: "DtIconWebex",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (t) => Object.keys(i).includes(t)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = c();
  }
}, d = ["aria-label", "data-qa", "aria-hidden"], u = ["fill"], _ = ["fill"], h = ["fill"], y = ["fill"], D = ["fill"], F = ["fill"], A = ["fill"], C = ["fill"], I = ["fill"], q = ["fill"], g = ["fill"], $ = ["fill"], U = ["fill"], m = ["fill"], B = ["fill"], S = ["fill"], E = ["fill"], O = ["fill"], G = ["fill"], Z = ["fill"], M = ["fill"], T = ["fill"], b = ["fill"], w = ["fill"], v = ["fill"], z = ["fill"], k = ["fill"], H = ["fill"], j = ["fill"], L = ["fill"], N = ["fill"], Q = ["fill"], V = ["fill"], W = ["fill"], R = ["fill"], J = ["id"], K = /* @__PURE__ */ o("stop", { "stop-color": "#227B60" }, null, -1), P = /* @__PURE__ */ o("stop", {
  offset: ".14",
  "stop-color": "#227B60",
  "stop-opacity": ".81"
}, null, -1), X = /* @__PURE__ */ o("stop", {
  offset: ".58",
  "stop-color": "#227B60",
  "stop-opacity": ".23"
}, null, -1), Y = /* @__PURE__ */ o("stop", {
  offset: ".78",
  "stop-color": "#227B60",
  "stop-opacity": "0"
}, null, -1), x = [
  K,
  P,
  X,
  Y
], o1 = ["id"], t1 = /* @__PURE__ */ o("stop", { "stop-color": "#227B60" }, null, -1), s1 = /* @__PURE__ */ o("stop", {
  offset: ".25",
  "stop-color": "#227B60",
  "stop-opacity": ".7"
}, null, -1), p1 = /* @__PURE__ */ o("stop", {
  offset: ".71",
  "stop-color": "#227B60",
  "stop-opacity": ".2"
}, null, -1), i1 = /* @__PURE__ */ o("stop", {
  offset: ".92",
  "stop-color": "#227B60",
  "stop-opacity": "0"
}, null, -1), e1 = [
  t1,
  s1,
  p1,
  i1
], c1 = ["id"], l1 = /* @__PURE__ */ s('<stop stop-color="#227B60"></stop><stop offset=".07" stop-color="#227B60" stop-opacity=".9"></stop><stop offset=".34" stop-color="#227B60" stop-opacity=".51"></stop><stop offset=".59" stop-color="#227B60" stop-opacity=".23"></stop><stop offset=".79" stop-color="#227B60" stop-opacity=".06"></stop><stop offset=".92" stop-color="#227B60" stop-opacity="0"></stop>', 6), a1 = [
  l1
], r1 = ["id"], n1 = /* @__PURE__ */ o("stop", { "stop-color": "#227B60" }, null, -1), f1 = /* @__PURE__ */ o("stop", {
  offset: ".36",
  "stop-color": "#227B60",
  "stop-opacity": ".63"
}, null, -1), d1 = /* @__PURE__ */ o("stop", {
  offset: ".92",
  "stop-color": "#227B60",
  "stop-opacity": "0"
}, null, -1), u1 = [
  n1,
  f1,
  d1
], _1 = ["id"], h1 = /* @__PURE__ */ s('<stop stop-color="#20735A"></stop><stop offset=".15" stop-color="#20745A" stop-opacity=".93"></stop><stop offset=".38" stop-color="#21755C" stop-opacity=".74"></stop><stop offset=".67" stop-color="#21785D" stop-opacity=".43"></stop><stop offset="1" stop-color="#227B60" stop-opacity="0"></stop>', 5), y1 = [
  h1
], D1 = ["id"], F1 = /* @__PURE__ */ o("stop", { "stop-color": "#227A61" }, null, -1), A1 = /* @__PURE__ */ o("stop", {
  offset: ".36",
  "stop-color": "#227A61",
  "stop-opacity": ".56"
}, null, -1), C1 = /* @__PURE__ */ o("stop", {
  offset: ".72",
  "stop-color": "#227A61",
  "stop-opacity": ".16"
}, null, -1), I1 = /* @__PURE__ */ o("stop", {
  offset: ".9",
  "stop-color": "#227A61",
  "stop-opacity": "0"
}, null, -1), q1 = [
  F1,
  A1,
  C1,
  I1
], g1 = ["id"], $1 = /* @__PURE__ */ s('<stop stop-color="#3CD9C3"></stop><stop offset=".07" stop-color="#3BD7C1" stop-opacity=".9"></stop><stop offset=".41" stop-color="#38CEB9" stop-opacity=".42"></stop><stop offset=".65" stop-color="#36C8B4" stop-opacity=".12"></stop><stop offset=".76" stop-color="#35C6B2" stop-opacity="0"></stop>', 5), U1 = [
  $1
], m1 = ["id"], B1 = /* @__PURE__ */ s('<stop stop-color="#3CD9C3"></stop><stop offset=".07" stop-color="#3BD7C1" stop-opacity=".9"></stop><stop offset=".41" stop-color="#38CEB9" stop-opacity=".42"></stop><stop offset=".65" stop-color="#36C8B4" stop-opacity=".12"></stop><stop offset=".76" stop-color="#35C6B2" stop-opacity="0"></stop>', 5), S1 = [
  B1
], E1 = ["id"], O1 = /* @__PURE__ */ s('<stop stop-color="#237F66" stop-opacity=".8"></stop><stop offset=".06" stop-color="#2C8C70" stop-opacity=".65"></stop><stop offset=".21" stop-color="#3DA785" stop-opacity=".37"></stop><stop offset=".35" stop-color="#4ABA93" stop-opacity=".17"></stop><stop offset=".47" stop-color="#51C59C" stop-opacity=".04"></stop><stop offset=".56" stop-color="#54C99F" stop-opacity="0"></stop>', 6), G1 = [
  O1
], Z1 = ["id"], M1 = /* @__PURE__ */ s('<stop stop-color="#167C8A"></stop><stop offset=".04" stop-color="#167C8A" stop-opacity=".93"></stop><stop offset=".33" stop-color="#177F8D" stop-opacity=".43"></stop><stop offset=".54" stop-color="#17818F" stop-opacity=".12"></stop><stop offset=".65" stop-color="#178290" stop-opacity="0"></stop>', 5), T1 = [
  M1
], b1 = ["id"], w1 = /* @__PURE__ */ s('<stop offset=".05" stop-color="#177D87"></stop><stop offset=".11" stop-color="#177E89" stop-opacity=".8"></stop><stop offset=".21" stop-color="#177F8B" stop-opacity=".52"></stop><stop offset=".32" stop-color="#17818D" stop-opacity=".29"></stop><stop offset=".42" stop-color="#17818F" stop-opacity=".13"></stop><stop offset=".51" stop-color="#178290" stop-opacity=".03"></stop><stop offset=".6" stop-color="#178290" stop-opacity="0"></stop>', 7), v1 = [
  w1
], z1 = ["id"], k1 = /* @__PURE__ */ s('<stop offset=".26" stop-color="#177F8A"></stop><stop offset=".27" stop-color="#177F8A" stop-opacity=".98"></stop><stop offset=".38" stop-color="#17808C" stop-opacity=".68"></stop><stop offset=".5" stop-color="#17818D" stop-opacity=".43"></stop><stop offset=".62" stop-color="#17818F" stop-opacity=".24"></stop><stop offset=".74" stop-color="#17828F" stop-opacity=".11"></stop><stop offset=".86" stop-color="#178290" stop-opacity=".03"></stop><stop offset="1" stop-color="#178290" stop-opacity="0"></stop>', 8), H1 = [
  k1
], j1 = ["id"], L1 = /* @__PURE__ */ s('<stop stop-color="#13656E"></stop><stop offset=".11" stop-color="#13646E" stop-opacity=".73"></stop><stop offset=".27" stop-color="#12646E" stop-opacity=".41"></stop><stop offset=".42" stop-color="#12636E" stop-opacity=".18"></stop><stop offset=".55" stop-color="#12636E" stop-opacity=".05"></stop><stop offset=".66" stop-color="#12636E" stop-opacity="0"></stop>', 6), N1 = [
  L1
], Q1 = ["id"], V1 = /* @__PURE__ */ s('<stop offset=".13" stop-color="#146A73"></stop><stop offset=".24" stop-color="#156F79" stop-opacity=".79"></stop><stop offset=".45" stop-color="#167783" stop-opacity=".45"></stop><stop offset=".65" stop-color="#167D8A" stop-opacity=".2"></stop><stop offset=".82" stop-color="#17818E" stop-opacity=".05"></stop><stop offset=".95" stop-color="#178290" stop-opacity="0"></stop>', 6), W1 = [
  V1
], R1 = ["id"], J1 = /* @__PURE__ */ s('<stop stop-color="#198E9C"></stop><stop offset=".1" stop-color="#198E9C" stop-opacity=".87"></stop><stop offset=".41" stop-color="#198E9C" stop-opacity=".5"></stop><stop offset=".67" stop-color="#198E9C" stop-opacity=".23"></stop><stop offset=".88" stop-color="#198E9C" stop-opacity=".06"></stop><stop offset="1" stop-color="#198E9C" stop-opacity="0"></stop>', 6), K1 = [
  J1
], P1 = ["id"], X1 = /* @__PURE__ */ o("stop", { "stop-color": "#1A3D9C" }, null, -1), Y1 = /* @__PURE__ */ o("stop", {
  offset: ".4",
  "stop-color": "#1A3D9C",
  "stop-opacity": ".42"
}, null, -1), x1 = /* @__PURE__ */ o("stop", {
  offset: ".7",
  "stop-color": "#1A3D9C",
  "stop-opacity": "0"
}, null, -1), o2 = [
  X1,
  Y1,
  x1
], t2 = ["id"], s2 = /* @__PURE__ */ o("stop", { "stop-color": "#1A3D9C" }, null, -1), p2 = /* @__PURE__ */ o("stop", {
  offset: ".4",
  "stop-color": "#1A3D9C",
  "stop-opacity": ".42"
}, null, -1), i2 = /* @__PURE__ */ o("stop", {
  offset: ".7",
  "stop-color": "#1A3D9C",
  "stop-opacity": "0"
}, null, -1), e2 = [
  s2,
  p2,
  i2
], c2 = ["id"], l2 = /* @__PURE__ */ o("stop", { "stop-color": "#1A3D9C" }, null, -1), a2 = /* @__PURE__ */ o("stop", {
  offset: ".4",
  "stop-color": "#1A3D9C",
  "stop-opacity": ".42"
}, null, -1), r2 = /* @__PURE__ */ o("stop", {
  offset: ".7",
  "stop-color": "#1A3D9C",
  "stop-opacity": "0"
}, null, -1), n2 = [
  l2,
  a2,
  r2
], f2 = ["id"], d2 = /* @__PURE__ */ s('<stop stop-color="#1A3D9C"></stop><stop offset=".16" stop-color="#1A3D9C" stop-opacity=".69"></stop><stop offset=".33" stop-color="#1A3D9C" stop-opacity=".4"></stop><stop offset=".49" stop-color="#1A3D9C" stop-opacity=".18"></stop><stop offset=".61" stop-color="#1A3D9C" stop-opacity=".05"></stop><stop offset=".7" stop-color="#1A3D9C" stop-opacity="0"></stop>', 6), u2 = [
  d2
], _2 = ["id"], h2 = /* @__PURE__ */ o("stop", { "stop-color": "#18388F" }, null, -1), y2 = /* @__PURE__ */ o("stop", {
  offset: ".37",
  "stop-color": "#193B96",
  "stop-opacity": ".45"
}, null, -1), D2 = /* @__PURE__ */ o("stop", {
  offset: ".7",
  "stop-color": "#1A3D9C",
  "stop-opacity": "0"
}, null, -1), F2 = [
  h2,
  y2,
  D2
], A2 = ["id"], C2 = /* @__PURE__ */ s('<stop stop-color="#18388F"></stop><stop offset=".09" stop-color="#183992" stop-opacity=".78"></stop><stop offset=".22" stop-color="#193B96" stop-opacity=".5"></stop><stop offset=".35" stop-color="#193C98" stop-opacity=".28"></stop><stop offset=".47" stop-color="#1A3C9A" stop-opacity=".13"></stop><stop offset=".59" stop-color="#1A3D9C" stop-opacity=".03"></stop><stop offset=".7" stop-color="#1A3D9C" stop-opacity="0"></stop>', 7), I2 = [
  C2
], q2 = ["id"], g2 = /* @__PURE__ */ s('<stop stop-color="#1A3D9C" stop-opacity=".78"></stop><stop offset=".24" stop-color="#1A3D9C" stop-opacity=".45"></stop><stop offset=".44" stop-color="#1A3D9C" stop-opacity=".2"></stop><stop offset=".6" stop-color="#1A3D9C" stop-opacity=".05"></stop><stop offset=".7" stop-color="#1A3D9C" stop-opacity="0"></stop>', 5), $2 = [
  g2
], U2 = ["id"], m2 = /* @__PURE__ */ s('<stop stop-color="#1A3D9C"></stop><stop offset=".4" stop-color="#1A3D9C" stop-opacity=".56"></stop><stop offset=".48" stop-color="#1A3D9C" stop-opacity=".43"></stop><stop offset=".69" stop-color="#1A3D9C" stop-opacity=".12"></stop><stop offset=".79" stop-color="#1A3D9C" stop-opacity="0"></stop>', 5), B2 = [
  m2
], S2 = ["id"], E2 = /* @__PURE__ */ s('<stop stop-color="#1A3D9C"></stop><stop offset=".06" stop-color="#1A3D9C" stop-opacity=".88"></stop><stop offset=".21" stop-color="#1A3D9C" stop-opacity=".61"></stop><stop offset=".36" stop-color="#1A3D9C" stop-opacity=".39"></stop><stop offset=".51" stop-color="#1A3D9C" stop-opacity=".22"></stop><stop offset=".67" stop-color="#1A3D9C" stop-opacity=".1"></stop><stop offset=".83" stop-color="#1A3D9C" stop-opacity=".02"></stop><stop offset="1" stop-color="#1A3D9C" stop-opacity="0"></stop>', 8), O2 = [
  E2
], G2 = ["id"], Z2 = /* @__PURE__ */ s('<stop stop-color="#1B3E9E"></stop><stop offset=".06" stop-color="#1B3E9E" stop-opacity=".87"></stop><stop offset=".21" stop-color="#1B3E9D" stop-opacity=".61"></stop><stop offset=".36" stop-color="#1A3D9D" stop-opacity=".39"></stop><stop offset=".52" stop-color="#1A3D9C" stop-opacity=".22"></stop><stop offset=".67" stop-color="#1A3D9C" stop-opacity=".1"></stop><stop offset=".83" stop-color="#1A3D9C" stop-opacity=".02"></stop><stop offset="1" stop-color="#1A3D9C" stop-opacity="0"></stop>', 8), M2 = [
  Z2
], T2 = ["id"], b2 = /* @__PURE__ */ s('<stop stop-color="#183991"></stop><stop offset=".03" stop-color="#183992" stop-opacity=".95"></stop><stop offset=".18" stop-color="#193A95" stop-opacity=".66"></stop><stop offset=".34" stop-color="#193B97" stop-opacity=".42"></stop><stop offset=".5" stop-color="#1A3C99" stop-opacity=".24"></stop><stop offset=".66" stop-color="#1A3D9B" stop-opacity=".1"></stop><stop offset=".82" stop-color="#1A3D9C" stop-opacity=".03"></stop><stop offset="1" stop-color="#1A3D9C" stop-opacity="0"></stop>', 8), w2 = [
  b2
], v2 = ["id"], z2 = /* @__PURE__ */ o("stop", {
  offset: ".04",
  "stop-color": "#2453D6",
  "stop-opacity": ".6"
}, null, -1), k2 = /* @__PURE__ */ o("stop", {
  offset: ".2",
  "stop-color": "#2453D6",
  "stop-opacity": ".49"
}, null, -1), H2 = /* @__PURE__ */ o("stop", {
  offset: ".52",
  "stop-color": "#2453D6",
  "stop-opacity": ".2"
}, null, -1), j2 = /* @__PURE__ */ o("stop", {
  offset: ".73",
  "stop-color": "#2453D6",
  "stop-opacity": "0"
}, null, -1), L2 = [
  z2,
  k2,
  H2,
  j2
], N2 = ["id"], Q2 = /* @__PURE__ */ s('<stop offset=".13" stop-color="#1CBBF3"></stop><stop offset=".34" stop-color="#1F99A5"></stop><stop offset=".45" stop-color="#209CA6"></stop><stop offset=".51" stop-color="#24A4AA"></stop><stop offset=".57" stop-color="#2BB3B0"></stop><stop offset=".6" stop-color="#30BDB4"></stop><stop offset=".79" stop-color="#38BA90"></stop><stop offset="1" stop-color="#60F05A"></stop>', 8), V2 = [
  Q2
], W2 = ["id"], R2 = /* @__PURE__ */ s('<stop offset=".13" stop-color="#2BF9FF"></stop><stop offset=".27" stop-color="#29F9FF" stop-opacity=".64"></stop><stop offset=".4" stop-color="#27FAFF" stop-opacity=".3"></stop><stop offset=".49" stop-color="#26FAFF" stop-opacity=".08"></stop><stop offset=".54" stop-color="#26FAFF" stop-opacity="0"></stop>', 5), J2 = [
  R2
], K2 = ["id"], P2 = /* @__PURE__ */ s('<stop stop-color="#26FAFF"></stop><stop offset=".06" stop-color="#26FAFF" stop-opacity=".88"></stop><stop offset=".24" stop-color="#26FAFF" stop-opacity=".51"></stop><stop offset=".39" stop-color="#26FAFF" stop-opacity=".23"></stop><stop offset=".5" stop-color="#26FAFF" stop-opacity=".06"></stop><stop offset=".55" stop-color="#26FAFF" stop-opacity="0"></stop>', 6), X2 = [
  P2
], Y2 = ["id"], x2 = /* @__PURE__ */ s('<stop stop-color="#21DEFF"></stop><stop offset=".04" stop-color="#21DEFF" stop-opacity=".88"></stop><stop offset=".17" stop-color="#21DEFF" stop-opacity=".51"></stop><stop offset=".27" stop-color="#21DEFF" stop-opacity=".23"></stop><stop offset=".34" stop-color="#21DEFF" stop-opacity=".06"></stop><stop offset=".38" stop-color="#21DEFF" stop-opacity="0"></stop>', 6), oo = [
  x2
], to = ["id"], so = /* @__PURE__ */ s('<stop offset=".62" stop-color="#21DEFF" stop-opacity="0"></stop><stop offset=".66" stop-color="#21DEFF" stop-opacity=".06"></stop><stop offset=".73" stop-color="#21DEFF" stop-opacity=".23"></stop><stop offset=".83" stop-color="#21DEFF" stop-opacity=".51"></stop><stop offset=".96" stop-color="#21DEFF" stop-opacity=".88"></stop><stop offset="1" stop-color="#21DEFF"></stop>', 6), po = [
  so
], io = ["id"], eo = /* @__PURE__ */ s('<stop stop-color="#44B044"></stop><stop offset=".11" stop-color="#44B044" stop-opacity=".8"></stop><stop offset=".27" stop-color="#44B044" stop-opacity=".52"></stop><stop offset=".43" stop-color="#44B044" stop-opacity=".29"></stop><stop offset=".58" stop-color="#44B044" stop-opacity=".13"></stop><stop offset=".7" stop-color="#44B044" stop-opacity=".03"></stop><stop offset=".8" stop-color="#44B044" stop-opacity="0"></stop>', 7), co = [
  eo
], lo = ["id"], ao = /* @__PURE__ */ o("stop", { "stop-color": "#3066FB" }, null, -1), ro = /* @__PURE__ */ o("stop", {
  offset: ".38",
  "stop-color": "#2F64F7"
}, null, -1), no = /* @__PURE__ */ o("stop", {
  offset: ".74",
  "stop-color": "#2857D9"
}, null, -1), fo = /* @__PURE__ */ o("stop", {
  offset: "1",
  "stop-color": "#3C7EFF"
}, null, -1), uo = [
  ao,
  ro,
  no,
  fo
], _o = ["id"], ho = /* @__PURE__ */ s('<stop stop-color="#3774FF"></stop><stop offset=".05" stop-color="#3774FF" stop-opacity=".91"></stop><stop offset=".16" stop-color="#3774FF" stop-opacity=".66"></stop><stop offset=".32" stop-color="#3774FF" stop-opacity=".28"></stop><stop offset=".43" stop-color="#3774FF" stop-opacity="0"></stop>', 5), yo = [
  ho
];
function Do(t, Fo, e, Ao, Co, p) {
  return a(), l("svg", {
    "aria-label": e.ariaLabel,
    class: r([p.iconSizeClass, "d-icon d-icon--webex"]),
    "data-qa": p.dataQA,
    "aria-hidden": p.ariaHidden,
    role: "img",
    "data-name": "Webex",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    o("path", {
      d: "M6.214 12.157c.977 3.254 2.393 5.271 3.487.616-.105-.015 2.224-6.176 2.322-6.414.898-1.195 2.344-1.931 3.846-1.917 2.965-.229 6.043 3.885 5.236 5.876-.552 1.44-2.624 1.747-3.577.538-.332-.412-.464-.934-.751-1.39-.555-1.033-1.288-1.136-1.76.022-.395.862-.607 1.758-.819 2.667l-.897 2.916-1.256 2.77a4.872 4.872 0 0 1-3.801 1.882c-5.89-.29-6.402-8.141-6.875-10.504-.066-.651-.003-.958.27-1.47.723-1.274 2.722-1.344 3.544-.134.292.403.347.92.403 1.402.123 1.054.336 2.107.628 3.14Z",
      fill: `url(#${t.uniqueID}a)`
    }, null, 8, u),
    o("path", {
      d: "M6.214 12.157c.977 3.254 2.393 5.271 3.487.616-.105-.015 2.224-6.176 2.322-6.414.898-1.195 2.344-1.931 3.846-1.917 2.965-.229 6.043 3.885 5.236 5.876-.552 1.44-2.624 1.747-3.577.538-.332-.412-.464-.934-.751-1.39-.555-1.033-1.288-1.136-1.76.022-.395.862-.607 1.758-.819 2.667l-.897 2.916-1.256 2.77a4.872 4.872 0 0 1-3.801 1.882c-5.89-.29-6.402-8.141-6.875-10.504-.066-.651-.003-.958.27-1.47.723-1.274 2.722-1.344 3.544-.134.292.403.347.92.403 1.402.123 1.054.336 2.107.628 3.14Z",
      fill: `url(#${t.uniqueID}b)`
    }, null, 8, _),
    o("path", {
      d: "M6.214 12.157c.977 3.254 2.393 5.271 3.487.616-.105-.015 2.224-6.176 2.322-6.414.898-1.195 2.344-1.931 3.846-1.917 2.965-.229 6.043 3.885 5.236 5.876-.552 1.44-2.624 1.747-3.577.538-.332-.412-.464-.934-.751-1.39-.555-1.033-1.288-1.136-1.76.022-.395.862-.607 1.758-.819 2.667l-.897 2.916-1.256 2.77a4.872 4.872 0 0 1-3.801 1.882c-5.89-.29-6.402-8.141-6.875-10.504-.066-.651-.003-.958.27-1.47.723-1.274 2.722-1.344 3.544-.134.292.403.347.92.403 1.402.123 1.054.336 2.107.628 3.14Z",
      fill: `url(#${t.uniqueID}c)`
    }, null, 8, h),
    o("path", {
      d: "M6.214 12.157c.977 3.254 2.393 5.271 3.487.616-.105-.015 2.224-6.176 2.322-6.414.898-1.195 2.344-1.931 3.846-1.917 2.965-.229 6.043 3.885 5.236 5.876-.552 1.44-2.624 1.747-3.577.538-.332-.412-.464-.934-.751-1.39-.555-1.033-1.288-1.136-1.76.022-.395.862-.607 1.758-.819 2.667l-.897 2.916-1.256 2.77a4.872 4.872 0 0 1-3.801 1.882c-5.89-.29-6.402-8.141-6.875-10.504-.066-.651-.003-.958.27-1.47.723-1.274 2.722-1.344 3.544-.134.292.403.347.92.403 1.402.123 1.054.336 2.107.628 3.14Z",
      fill: `url(#${t.uniqueID}d)`
    }, null, 8, y),
    o("path", {
      d: "M6.214 12.157c.977 3.254 2.393 5.271 3.487.616-.105-.015 2.224-6.176 2.322-6.414.898-1.195 2.344-1.931 3.846-1.917 2.965-.229 6.043 3.885 5.236 5.876-.552 1.44-2.624 1.747-3.577.538-.332-.412-.464-.934-.751-1.39-.555-1.033-1.288-1.136-1.76.022-.395.862-.607 1.758-.819 2.667l-.897 2.916-1.256 2.77a4.872 4.872 0 0 1-3.801 1.882c-5.89-.29-6.402-8.141-6.875-10.504-.066-.651-.003-.958.27-1.47.723-1.274 2.722-1.344 3.544-.134.292.403.347.92.403 1.402.123 1.054.336 2.107.628 3.14Z",
      fill: `url(#${t.uniqueID}e)`
    }, null, 8, D),
    o("path", {
      d: "M6.214 12.157c.977 3.254 2.393 5.271 3.487.616-.105-.015 2.224-6.176 2.322-6.414.898-1.195 2.344-1.931 3.846-1.917 2.965-.229 6.043 3.885 5.236 5.876-.552 1.44-2.624 1.747-3.577.538-.332-.412-.464-.934-.751-1.39-.555-1.033-1.288-1.136-1.76.022-.395.862-.607 1.758-.819 2.667l-.897 2.916-1.256 2.77a4.872 4.872 0 0 1-3.801 1.882c-5.89-.29-6.402-8.141-6.875-10.504-.066-.651-.003-.958.27-1.47.723-1.274 2.722-1.344 3.544-.134.292.403.347.92.403 1.402.123 1.054.336 2.107.628 3.14Z",
      fill: `url(#${t.uniqueID}f)`
    }, null, 8, F),
    o("path", {
      d: "M6.214 12.157c.977 3.254 2.393 5.271 3.487.616-.105-.015 2.224-6.176 2.322-6.414.898-1.195 2.344-1.931 3.846-1.917 2.965-.229 6.043 3.885 5.236 5.876-.552 1.44-2.624 1.747-3.577.538-.332-.412-.464-.934-.751-1.39-.555-1.033-1.288-1.136-1.76.022-.395.862-.607 1.758-.819 2.667l-.897 2.916-1.256 2.77a4.872 4.872 0 0 1-3.801 1.882c-5.89-.29-6.402-8.141-6.875-10.504-.066-.651-.003-.958.27-1.47.723-1.274 2.722-1.344 3.544-.134.292.403.347.92.403 1.402.123 1.054.336 2.107.628 3.14Z",
      fill: `url(#${t.uniqueID}g)`
    }, null, 8, A),
    o("path", {
      d: "M6.214 12.157c.977 3.254 2.393 5.271 3.487.616-.105-.015 2.224-6.176 2.322-6.414.898-1.195 2.344-1.931 3.846-1.917 2.965-.229 6.043 3.885 5.236 5.876-.552 1.44-2.624 1.747-3.577.538-.332-.412-.464-.934-.751-1.39-.555-1.033-1.288-1.136-1.76.022-.395.862-.607 1.758-.819 2.667l-.897 2.916-1.256 2.77a4.872 4.872 0 0 1-3.801 1.882c-5.89-.29-6.402-8.141-6.875-10.504-.066-.651-.003-.958.27-1.47.723-1.274 2.722-1.344 3.544-.134.292.403.347.92.403 1.402.123 1.054.336 2.107.628 3.14Z",
      fill: `url(#${t.uniqueID}h)`
    }, null, 8, C),
    o("path", {
      d: "M6.214 12.157c.977 3.254 2.393 5.271 3.487.616-.105-.015 2.224-6.176 2.322-6.414.898-1.195 2.344-1.931 3.846-1.917 2.965-.229 6.043 3.885 5.236 5.876-.552 1.44-2.624 1.747-3.577.538-.332-.412-.464-.934-.751-1.39-.555-1.033-1.288-1.136-1.76.022-.395.862-.607 1.758-.819 2.667l-.897 2.916-1.256 2.77a4.872 4.872 0 0 1-3.801 1.882c-5.89-.29-6.402-8.141-6.875-10.504-.066-.651-.003-.958.27-1.47.723-1.274 2.722-1.344 3.544-.134.292.403.347.92.403 1.402.123 1.054.336 2.107.628 3.14Z",
      fill: `url(#${t.uniqueID}i)`
    }, null, 8, I),
    o("path", {
      d: "M6.214 12.157c.977 3.254 2.393 5.271 3.487.616-.105-.015 2.224-6.176 2.322-6.414.898-1.195 2.344-1.931 3.846-1.917 2.965-.229 6.043 3.885 5.236 5.876-.552 1.44-2.624 1.747-3.577.538-.332-.412-.464-.934-.751-1.39-.555-1.033-1.288-1.136-1.76.022-.395.862-.607 1.758-.819 2.667l-.897 2.916-1.256 2.77a4.872 4.872 0 0 1-3.801 1.882c-5.89-.29-6.402-8.141-6.875-10.504-.066-.651-.003-.958.27-1.47.723-1.274 2.722-1.344 3.544-.134.292.403.347.92.403 1.402.123 1.054.336 2.107.628 3.14Z",
      fill: `url(#${t.uniqueID}j)`
    }, null, 8, q),
    o("path", {
      d: "M6.214 12.157c.977 3.254 2.393 5.271 3.487.616-.105-.015 2.224-6.176 2.322-6.414.898-1.195 2.344-1.931 3.846-1.917 2.965-.229 6.043 3.885 5.236 5.876-.552 1.44-2.624 1.747-3.577.538-.332-.412-.464-.934-.751-1.39-.555-1.033-1.288-1.136-1.76.022-.395.862-.607 1.758-.819 2.667l-.897 2.916-1.256 2.77a4.872 4.872 0 0 1-3.801 1.882c-5.89-.29-6.402-8.141-6.875-10.504-.066-.651-.003-.958.27-1.47.723-1.274 2.722-1.344 3.544-.134.292.403.347.92.403 1.402.123 1.054.336 2.107.628 3.14Z",
      fill: `url(#${t.uniqueID}k)`
    }, null, 8, g),
    o("path", {
      d: "M6.214 12.157c.977 3.254 2.393 5.271 3.487.616-.105-.015 2.224-6.176 2.322-6.414.898-1.195 2.344-1.931 3.846-1.917 2.965-.229 6.043 3.885 5.236 5.876-.552 1.44-2.624 1.747-3.577.538-.332-.412-.464-.934-.751-1.39-.555-1.033-1.288-1.136-1.76.022-.395.862-.607 1.758-.819 2.667l-.897 2.916-1.256 2.77a4.872 4.872 0 0 1-3.801 1.882c-5.89-.29-6.402-8.141-6.875-10.504-.066-.651-.003-.958.27-1.47.723-1.274 2.722-1.344 3.544-.134.292.403.347.92.403 1.402.123 1.054.336 2.107.628 3.14Z",
      fill: `url(#${t.uniqueID}l)`
    }, null, 8, $),
    o("path", {
      d: "M6.214 12.157c.977 3.254 2.393 5.271 3.487.616-.105-.015 2.224-6.176 2.322-6.414.898-1.195 2.344-1.931 3.846-1.917 2.965-.229 6.043 3.885 5.236 5.876-.552 1.44-2.624 1.747-3.577.538-.332-.412-.464-.934-.751-1.39-.555-1.033-1.288-1.136-1.76.022-.395.862-.607 1.758-.819 2.667l-.897 2.916-1.256 2.77a4.872 4.872 0 0 1-3.801 1.882c-5.89-.29-6.402-8.141-6.875-10.504-.066-.651-.003-.958.27-1.47.723-1.274 2.722-1.344 3.544-.134.292.403.347.92.403 1.402.123 1.054.336 2.107.628 3.14Z",
      fill: `url(#${t.uniqueID}m)`
    }, null, 8, U),
    o("path", {
      d: "M6.214 12.157c.977 3.254 2.393 5.271 3.487.616-.105-.015 2.224-6.176 2.322-6.414.898-1.195 2.344-1.931 3.846-1.917 2.965-.229 6.043 3.885 5.236 5.876-.552 1.44-2.624 1.747-3.577.538-.332-.412-.464-.934-.751-1.39-.555-1.033-1.288-1.136-1.76.022-.395.862-.607 1.758-.819 2.667l-.897 2.916-1.256 2.77a4.872 4.872 0 0 1-3.801 1.882c-5.89-.29-6.402-8.141-6.875-10.504-.066-.651-.003-.958.27-1.47.723-1.274 2.722-1.344 3.544-.134.292.403.347.92.403 1.402.123 1.054.336 2.107.628 3.14Z",
      fill: `url(#${t.uniqueID}n)`
    }, null, 8, m),
    o("path", {
      d: "M6.214 12.157c.977 3.254 2.393 5.271 3.487.616-.105-.015 2.224-6.176 2.322-6.414.898-1.195 2.344-1.931 3.846-1.917 2.965-.229 6.043 3.885 5.236 5.876-.552 1.44-2.624 1.747-3.577.538-.332-.412-.464-.934-.751-1.39-.555-1.033-1.288-1.136-1.76.022-.395.862-.607 1.758-.819 2.667l-.897 2.916-1.256 2.77a4.872 4.872 0 0 1-3.801 1.882c-5.89-.29-6.402-8.141-6.875-10.504-.066-.651-.003-.958.27-1.47.723-1.274 2.722-1.344 3.544-.134.292.403.347.92.403 1.402.123 1.054.336 2.107.628 3.14Z",
      fill: `url(#${t.uniqueID}o)`
    }, null, 8, B),
    o("path", {
      d: "M6.214 12.157c.977 3.254 2.393 5.271 3.487.616-.105-.015 2.224-6.176 2.322-6.414.898-1.195 2.344-1.931 3.846-1.917 2.965-.229 6.043 3.885 5.236 5.876-.552 1.44-2.624 1.747-3.577.538-.332-.412-.464-.934-.751-1.39-.555-1.033-1.288-1.136-1.76.022-.395.862-.607 1.758-.819 2.667l-.897 2.916-1.256 2.77a4.872 4.872 0 0 1-3.801 1.882c-5.89-.29-6.402-8.141-6.875-10.504-.066-.651-.003-.958.27-1.47.723-1.274 2.722-1.344 3.544-.134.292.403.347.92.403 1.402.123 1.054.336 2.107.628 3.14Z",
      fill: `url(#${t.uniqueID}p)`
    }, null, 8, S),
    o("path", {
      d: "M6.214 12.157c.977 3.254 2.393 5.271 3.487.616-.105-.015 2.224-6.176 2.322-6.414.898-1.195 2.344-1.931 3.846-1.917 2.965-.229 6.043 3.885 5.236 5.876-.552 1.44-2.624 1.747-3.577.538-.332-.412-.464-.934-.751-1.39-.555-1.033-1.288-1.136-1.76.022-.395.862-.607 1.758-.819 2.667l-.897 2.916-1.256 2.77a4.872 4.872 0 0 1-3.801 1.882c-5.89-.29-6.402-8.141-6.875-10.504-.066-.651-.003-.958.27-1.47.723-1.274 2.722-1.344 3.544-.134.292.403.347.92.403 1.402.123 1.054.336 2.107.628 3.14Z",
      fill: `url(#${t.uniqueID}q)`
    }, null, 8, E),
    o("path", {
      d: "M6.214 12.157c.977 3.254 2.393 5.271 3.487.616-.105-.015 2.224-6.176 2.322-6.414.898-1.195 2.344-1.931 3.846-1.917 2.965-.229 6.043 3.885 5.236 5.876-.552 1.44-2.624 1.747-3.577.538-.332-.412-.464-.934-.751-1.39-.555-1.033-1.288-1.136-1.76.022-.395.862-.607 1.758-.819 2.667l-.897 2.916-1.256 2.77a4.872 4.872 0 0 1-3.801 1.882c-5.89-.29-6.402-8.141-6.875-10.504-.066-.651-.003-.958.27-1.47.723-1.274 2.722-1.344 3.544-.134.292.403.347.92.403 1.402.123 1.054.336 2.107.628 3.14Z",
      fill: `url(#${t.uniqueID}r)`
    }, null, 8, O),
    o("path", {
      d: "M6.214 12.157c.977 3.254 2.393 5.271 3.487.616-.105-.015 2.224-6.176 2.322-6.414.898-1.195 2.344-1.931 3.846-1.917 2.965-.229 6.043 3.885 5.236 5.876-.552 1.44-2.624 1.747-3.577.538-.332-.412-.464-.934-.751-1.39-.555-1.033-1.288-1.136-1.76.022-.395.862-.607 1.758-.819 2.667l-.897 2.916-1.256 2.77a4.872 4.872 0 0 1-3.801 1.882c-5.89-.29-6.402-8.141-6.875-10.504-.066-.651-.003-.958.27-1.47.723-1.274 2.722-1.344 3.544-.134.292.403.347.92.403 1.402.123 1.054.336 2.107.628 3.14Z",
      fill: `url(#${t.uniqueID}s)`
    }, null, 8, G),
    o("path", {
      d: "M6.214 12.157c.977 3.254 2.393 5.271 3.487.616-.105-.015 2.224-6.176 2.322-6.414.898-1.195 2.344-1.931 3.846-1.917 2.965-.229 6.043 3.885 5.236 5.876-.552 1.44-2.624 1.747-3.577.538-.332-.412-.464-.934-.751-1.39-.555-1.033-1.288-1.136-1.76.022-.395.862-.607 1.758-.819 2.667l-.897 2.916-1.256 2.77a4.872 4.872 0 0 1-3.801 1.882c-5.89-.29-6.402-8.141-6.875-10.504-.066-.651-.003-.958.27-1.47.723-1.274 2.722-1.344 3.544-.134.292.403.347.92.403 1.402.123 1.054.336 2.107.628 3.14Z",
      fill: `url(#${t.uniqueID}t)`
    }, null, 8, Z),
    o("path", {
      d: "m10.642 10.016 1.379-3.667c1.525-2.114 4.788-2.57 6.807-.898 1.412 1.065 2.254 3.174 2.254 3.174.358.77.176 1.776-.437 2.366-.84.873-2.36.795-3.117-.145-.502-.556-.941-2.637-1.984-2.12-.78.772-.95 1.976-1.245 2.984-.003.195-.92 3.077-.998 3.352l-2.657-5.045-.002-.001Z",
      fill: `url(#${t.uniqueID}u)`
    }, null, 8, M),
    o("path", {
      d: "M20.61 6.752c-.178 0-.359.022-.526.068.506.83 1.099 1.68 1.123 2.68.053 1.578-1.783 2.66-3.12 1.816-.474 2.005-2.003 6.357-3.25 2.984-.608-1.796-.8-3.042-1.29-4.71-1.37-5.86-6.926-6.632-9.542-2.77 1.02.237 1.525 1.264 1.581 2.209.062 1.059.326 2.085.617 3.106 1.686-5.18 2.684-3.857 3.476-.628.763 3.262 1.634 6.646 3.812 7.636 2.868 1.541 6.014-.056 7.22-2.793.926-1.824 1.475-3.794 1.794-5.808.094-.804.352-1.654.08-2.445a2.154 2.154 0 0 0-1.975-1.345Z",
      fill: `url(#${t.uniqueID}v)`
    }, null, 8, T),
    o("path", {
      d: "M20.61 6.752c-.178 0-.359.022-.526.068.506.83 1.153 1.68 1.178 2.68.052 1.578-1.838 2.66-3.174 1.816-.475 2.005-2.004 6.357-3.252 2.984-.607-1.796-.8-3.042-1.289-4.71-1.37-5.86-6.926-6.632-9.542-2.77 1.02.237 1.563 1.216 1.581 2.209a19.47 19.47 0 0 0 .617 3.106c1.686-5.18 2.684-3.857 3.476-.628.763 3.262 1.634 6.646 3.812 7.636 2.868 1.541 6.014-.056 7.22-2.793.926-1.824 1.475-3.794 1.794-5.808.094-.804.352-1.654.08-2.445a2.154 2.154 0 0 0-1.975-1.345Z",
      fill: `url(#${t.uniqueID}w)`
    }, null, 8, b),
    o("path", {
      d: "M20.61 6.752c-.178 0-.359.022-.526.068.506.83 1.153 1.68 1.178 2.68.052 1.578-1.838 2.66-3.174 1.816-.475 2.005-2.004 6.357-3.252 2.984-.607-1.796-.8-3.042-1.289-4.71-1.37-5.86-6.926-6.632-9.542-2.77 1.02.237 1.563 1.216 1.581 2.209a19.47 19.47 0 0 0 .617 3.106c1.686-5.18 2.684-3.857 3.476-.628.763 3.262 1.634 6.646 3.812 7.636 2.868 1.541 6.014-.056 7.22-2.793.926-1.824 1.475-3.794 1.794-5.808.094-.804.352-1.654.08-2.445a2.154 2.154 0 0 0-1.975-1.345Z",
      fill: `url(#${t.uniqueID}x)`
    }, null, 8, w),
    o("path", {
      d: "M20.61 6.752c-.178 0-.359.022-.526.068.506.83 1.153 1.68 1.178 2.68.052 1.578-1.838 2.66-3.174 1.816-.475 2.005-2.004 6.357-3.252 2.984-.607-1.796-.8-3.042-1.289-4.71-1.37-5.86-6.926-6.632-9.542-2.77 1.02.237 1.563 1.216 1.581 2.209a19.47 19.47 0 0 0 .617 3.106c1.686-5.18 2.684-3.857 3.476-.628.763 3.262 1.634 6.646 3.812 7.636 2.868 1.541 6.014-.056 7.22-2.793.926-1.824 1.475-3.794 1.794-5.808.094-.804.352-1.654.08-2.445a2.154 2.154 0 0 0-1.975-1.345Z",
      fill: `url(#${t.uniqueID}y)`
    }, null, 8, v),
    o("path", {
      d: "M20.61 6.752c-.178 0-.359.022-.526.068.506.83 1.153 1.68 1.178 2.68.052 1.578-1.838 2.66-3.174 1.816-.475 2.005-2.004 6.357-3.252 2.984-.607-1.796-.8-3.042-1.289-4.71-1.37-5.86-6.926-6.632-9.542-2.77 1.02.237 1.563 1.216 1.581 2.209a19.47 19.47 0 0 0 .617 3.106c1.686-5.18 2.684-3.857 3.476-.628.763 3.262 1.634 6.646 3.812 7.636 2.868 1.541 6.014-.056 7.22-2.793.926-1.824 1.475-3.794 1.794-5.808.094-.804.352-1.654.08-2.445a2.154 2.154 0 0 0-1.975-1.345Z",
      fill: `url(#${t.uniqueID}z)`
    }, null, 8, z),
    o("path", {
      d: "M20.61 6.752c-.178 0-.359.022-.526.068.506.83 1.153 1.68 1.178 2.68.052 1.578-1.838 2.66-3.174 1.816-.475 2.005-2.004 6.357-3.252 2.984-.607-1.796-.8-3.042-1.289-4.71-1.37-5.86-6.926-6.632-9.542-2.77 1.02.237 1.563 1.216 1.581 2.209a19.47 19.47 0 0 0 .617 3.106c1.686-5.18 2.684-3.857 3.476-.628.763 3.262 1.634 6.646 3.812 7.636 2.868 1.541 6.014-.056 7.22-2.793.926-1.824 1.475-3.794 1.794-5.808.094-.804.352-1.654.08-2.445a2.154 2.154 0 0 0-1.975-1.345Z",
      fill: `url(#${t.uniqueID}A)`
    }, null, 8, k),
    o("path", {
      d: "M20.61 6.752c-.178 0-.359.022-.526.068.506.83 1.153 1.68 1.178 2.68.052 1.578-1.838 2.66-3.174 1.816-.475 2.005-2.004 6.357-3.252 2.984-.607-1.796-.8-3.042-1.289-4.71-1.37-5.86-6.926-6.632-9.542-2.77 1.02.237 1.563 1.216 1.581 2.209a19.47 19.47 0 0 0 .617 3.106c1.686-5.18 2.684-3.857 3.476-.628.763 3.262 1.634 6.646 3.812 7.636 2.868 1.541 6.014-.056 7.22-2.793.926-1.824 1.475-3.794 1.794-5.808.094-.804.352-1.654.08-2.445a2.154 2.154 0 0 0-1.975-1.345Z",
      fill: `url(#${t.uniqueID}B)`
    }, null, 8, H),
    o("path", {
      d: "M20.61 6.752c-.178 0-.359.022-.526.068.506.83 1.153 1.68 1.178 2.68.052 1.578-1.838 2.66-3.174 1.816-.475 2.005-2.004 6.357-3.252 2.984-.607-1.796-.8-3.042-1.289-4.71-1.37-5.86-6.926-6.632-9.542-2.77 1.02.237 1.563 1.216 1.581 2.209a19.47 19.47 0 0 0 .617 3.106c1.686-5.18 2.684-3.857 3.476-.628.763 3.262 1.634 6.646 3.812 7.636 2.868 1.541 6.014-.056 7.22-2.793.926-1.824 1.475-3.794 1.794-5.808.094-.804.352-1.654.08-2.445a2.154 2.154 0 0 0-1.975-1.345Z",
      fill: `url(#${t.uniqueID}C)`
    }, null, 8, j),
    o("path", {
      d: "M20.61 6.752c-.178 0-.359.022-.526.068.506.83 1.153 1.68 1.178 2.68.052 1.578-1.838 2.66-3.174 1.816-.475 2.005-2.004 6.357-3.252 2.984-.607-1.796-.8-3.042-1.289-4.71-1.37-5.86-6.926-6.632-9.542-2.77 1.02.237 1.563 1.216 1.581 2.209a19.47 19.47 0 0 0 .617 3.106c1.686-5.18 2.684-3.857 3.476-.628.763 3.262 1.634 6.646 3.812 7.636 2.868 1.541 6.014-.056 7.22-2.793.926-1.824 1.475-3.794 1.794-5.808.094-.804.352-1.654.08-2.445a2.154 2.154 0 0 0-1.975-1.345Z",
      fill: `url(#${t.uniqueID}D)`
    }, null, 8, L),
    o("path", {
      d: "M20.61 6.752c-.178 0-.359.022-.526.068.506.83 1.153 1.68 1.178 2.68.052 1.578-1.838 2.66-3.174 1.816-.475 2.005-2.004 6.357-3.252 2.984-.607-1.796-.8-3.042-1.289-4.71-1.37-5.86-6.926-6.632-9.542-2.77 1.02.237 1.563 1.216 1.581 2.209a19.47 19.47 0 0 0 .617 3.106c1.686-5.18 2.684-3.857 3.476-.628.763 3.262 1.634 6.646 3.812 7.636 2.868 1.541 6.014-.056 7.22-2.793.926-1.824 1.475-3.794 1.794-5.808.094-.804.352-1.654.08-2.445a2.154 2.154 0 0 0-1.975-1.345Z",
      fill: `url(#${t.uniqueID}E)`
    }, null, 8, N),
    o("path", {
      d: "M20.61 6.752c-.178 0-.359.022-.526.068.506.83 1.153 1.68 1.178 2.68.052 1.578-1.838 2.66-3.174 1.816-.475 2.005-2.004 6.357-3.252 2.984-.607-1.796-.8-3.042-1.289-4.71-1.37-5.86-6.926-6.632-9.542-2.77 1.02.237 1.563 1.216 1.581 2.209a19.47 19.47 0 0 0 .617 3.106c1.686-5.18 2.684-3.857 3.476-.628.763 3.262 1.634 6.646 3.812 7.636 2.868 1.541 6.014-.056 7.22-2.793.926-1.824 1.475-3.794 1.794-5.808.094-.804.352-1.654.08-2.445a2.154 2.154 0 0 0-1.975-1.345Z",
      fill: `url(#${t.uniqueID}F)`
    }, null, 8, Q),
    o("path", {
      d: "M20.61 6.752c-.178 0-.359.022-.526.068.506.83 1.153 1.68 1.178 2.68.052 1.578-1.838 2.66-3.174 1.816-.475 2.005-2.004 6.357-3.252 2.984-.607-1.796-.8-3.042-1.289-4.71-1.37-5.86-6.926-6.632-9.542-2.77 1.02.237 1.563 1.216 1.581 2.209a19.47 19.47 0 0 0 .617 3.106c1.686-5.18 2.684-3.857 3.476-.628.763 3.262 1.634 6.646 3.812 7.636 2.868 1.541 6.014-.056 7.22-2.793.926-1.824 1.475-3.794 1.794-5.808.094-.804.352-1.654.08-2.445a2.154 2.154 0 0 0-1.975-1.345Z",
      fill: `url(#${t.uniqueID}G)`
    }, null, 8, V),
    o("path", {
      d: "M20.61 6.752c-.178 0-.359.022-.526.068.506.83 1.153 1.68 1.178 2.68.052 1.578-1.838 2.66-3.174 1.816-.475 2.005-2.004 6.357-3.252 2.984-.607-1.796-.8-3.042-1.289-4.71-1.37-5.86-6.926-6.632-9.542-2.77 1.02.237 1.563 1.216 1.581 2.209a19.47 19.47 0 0 0 .617 3.106c1.686-5.18 2.684-3.857 3.476-.628.763 3.262 1.634 6.646 3.812 7.636 2.868 1.541 6.014-.056 7.22-2.793.926-1.824 1.475-3.794 1.794-5.808.094-.804.352-1.654.08-2.445a2.154 2.154 0 0 0-1.975-1.345Z",
      fill: `url(#${t.uniqueID}H)`
    }, null, 8, W),
    o("path", {
      d: "M20.61 6.752c-.178 0-.359.022-.526.068.506.83 1.099 1.68 1.123 2.68.053 1.578-1.783 2.66-3.12 1.816-.474 2.005-2.003 6.357-3.25 2.984-.608-1.796-.8-3.042-1.29-4.71-1.37-5.86-6.926-6.632-9.542-2.77 1.02.237 1.563 1.216 1.581 2.209a19.47 19.47 0 0 0 .617 3.106c1.686-5.18 2.684-3.857 3.476-.628.763 3.262 1.634 6.646 3.812 7.636 2.868 1.541 6.014-.056 7.22-2.793.926-1.824 1.475-3.794 1.794-5.808.094-.804.352-1.654.08-2.445a2.154 2.154 0 0 0-1.975-1.345Z",
      fill: `url(#${t.uniqueID}I)`
    }, null, 8, R),
    o("defs", null, [
      o("radialGradient", {
        id: `${t.uniqueID}b`,
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "matrix(2.13439 7.60352 -5.7791 1.62226 13.31 10.864)"
      }, x, 8, J),
      o("radialGradient", {
        id: `${t.uniqueID}c`,
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "rotate(91.15 2.372 12.498) scale(5.34037 4.0585)"
      }, e1, 8, o1),
      o("radialGradient", {
        id: `${t.uniqueID}d`,
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "matrix(.12163 4.97661 -3.53355 .08636 14.406 10.475)"
      }, a1, 8, c1),
      o("radialGradient", {
        id: `${t.uniqueID}e`,
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "rotate(88.6 2.116 12.62) scale(4.01949 2.85355)"
      }, u1, 8, r1),
      o("radialGradient", {
        id: `${t.uniqueID}f`,
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "matrix(.07832 3.20482 -2.05149 .05014 14.505 10.46)"
      }, y1, 8, _1),
      o("radialGradient", {
        id: `${t.uniqueID}g`,
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "matrix(4.71998 2.08176 -1.56132 3.53999 15.107 10.823)"
      }, q1, 8, D1),
      o("radialGradient", {
        id: `${t.uniqueID}h`,
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "rotate(35.27 1.871 22.367) scale(6.87972 6.29006)"
      }, U1, 8, g1),
      o("radialGradient", {
        id: `${t.uniqueID}i`,
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "rotate(35.27 3992.42 -16350.874) scale(1222.04 857.335)"
      }, S1, 8, m1),
      o("radialGradient", {
        id: `${t.uniqueID}j`,
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "matrix(-1.15454 5.95627 -7.36134 -1.4269 15.633 12.59)"
      }, G1, 8, E1),
      o("radialGradient", {
        id: `${t.uniqueID}k`,
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "matrix(5.00898 -6.14599 6.63764 5.40967 12.659 12.66)"
      }, T1, 8, Z1),
      o("radialGradient", {
        id: `${t.uniqueID}l`,
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "rotate(-31.66 29.596 -14.578) scale(7.83644 6.19101)"
      }, v1, 8, b1),
      o("radialGradient", {
        id: `${t.uniqueID}m`,
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "rotate(-130.54 8.123 4.305) scale(4.60803 3.62824)"
      }, H1, 8, z1),
      o("radialGradient", {
        id: `${t.uniqueID}n`,
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "rotate(-173.11 5.113 7.166) scale(4.32268)"
      }, N1, 8, j1),
      o("radialGradient", {
        id: `${t.uniqueID}o`,
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "matrix(-1.49979 -2.6704 2.24306 -1.25978 9.292 15.322)"
      }, W1, 8, Q1),
      o("radialGradient", {
        id: `${t.uniqueID}p`,
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "matrix(1.59048 -2.3571 1.86739 1.26004 8.97 13.84)"
      }, K1, 8, R1),
      o("radialGradient", {
        id: `${t.uniqueID}w`,
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "rotate(98.69 3.769 13.248) scale(9.50365 6.27223)"
      }, o2, 8, P1),
      o("radialGradient", {
        id: `${t.uniqueID}x`,
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "rotate(98.69 3564.115 -4205.073) scale(1169.36 630.292)"
      }, e2, 8, t2),
      o("radialGradient", {
        id: `${t.uniqueID}y`,
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "matrix(-208.73104 1376.9188 -568.63835 -86.2015 449.639 -8432.51)"
      }, n2, 8, c2),
      o("radialGradient", {
        id: `${t.uniqueID}z`,
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "rotate(83.09 1.625 15.09) scale(8.3065 5.79627)"
      }, u2, 8, f2),
      o("radialGradient", {
        id: `${t.uniqueID}A`,
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "matrix(2.11462 7.69808 -5.23453 1.4379 17.747 12.507)"
      }, F2, 8, _2),
      o("radialGradient", {
        id: `${t.uniqueID}B`,
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "rotate(74.64 -1 18.508) scale(3.71184 3.52569)"
      }, I2, 8, A2),
      o("radialGradient", {
        id: `${t.uniqueID}C`,
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "rotate(74.64 -1.39 18.874) scale(3.71184 3.52569)"
      }, $2, 8, q2),
      o("radialGradient", {
        id: `${t.uniqueID}D`,
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "rotate(67.03 -5.966 12.195) scale(8.85826 5.87875)"
      }, B2, 8, U2),
      o("radialGradient", {
        id: `${t.uniqueID}E`,
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "rotate(76.1 -3.631 9.511) scale(6.57096 4.33828)"
      }, O2, 8, S2),
      o("radialGradient", {
        id: `${t.uniqueID}F`,
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "rotate(76.1 -3.631 9.511) scale(6.57096 4.33828)"
      }, M2, 8, G2),
      o("radialGradient", {
        id: `${t.uniqueID}G`,
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "matrix(1.20766 4.87994 -3.22119 .79716 7.038 10.013)"
      }, w2, 8, T2),
      o("radialGradient", {
        id: `${t.uniqueID}H`,
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "matrix(.19816 3.96661 -3.49235 .17447 8.602 11.48)"
      }, L2, 8, v2),
      o("linearGradient", {
        id: `${t.uniqueID}a`,
        x1: "2.239",
        y1: "14.79",
        x2: "18.928",
        y2: "8.043",
        gradientUnits: "userSpaceOnUse"
      }, V2, 8, N2),
      o("linearGradient", {
        id: `${t.uniqueID}q`,
        x1: "3.364",
        y1: "4.084",
        x2: "10.702",
        y2: "10.875",
        gradientUnits: "userSpaceOnUse"
      }, J2, 8, W2),
      o("linearGradient", {
        id: `${t.uniqueID}r`,
        x1: "-.806",
        y1: "15.169",
        x2: "7.761",
        y2: "12.739",
        gradientUnits: "userSpaceOnUse"
      }, X2, 8, K2),
      o("linearGradient", {
        id: `${t.uniqueID}s`,
        x1: "1.434",
        y1: "14.882",
        x2: "11.114",
        y2: "11.432",
        gradientUnits: "userSpaceOnUse"
      }, oo, 8, Y2),
      o("linearGradient", {
        id: `${t.uniqueID}t`,
        x1: "10.664",
        y1: "9.876",
        x2: "16.065",
        y2: "18.686",
        gradientUnits: "userSpaceOnUse"
      }, po, 8, to),
      o("linearGradient", {
        id: `${t.uniqueID}u`,
        x1: "16.677",
        y1: "13.17",
        x2: "15.83",
        y2: "9.031",
        gradientUnits: "userSpaceOnUse"
      }, co, 8, io),
      o("linearGradient", {
        id: `${t.uniqueID}v`,
        x1: "4.819",
        y1: "8.885",
        x2: "22.692",
        y2: "14.803",
        gradientUnits: "userSpaceOnUse"
      }, uo, 8, lo),
      o("linearGradient", {
        id: `${t.uniqueID}I`,
        x1: "16.438",
        y1: "1.578",
        x2: "11.921",
        y2: "12.742",
        gradientUnits: "userSpaceOnUse"
      }, yo, 8, _o)
    ])
  ], 10, d);
}
const Uo = /* @__PURE__ */ n(f, [["render", Do]]);
export {
  Uo as default
};
//# sourceMappingURL=webex.js.map
